export default "__VITE_ASSET__19273f0e__"